import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import BatchStatusBadge from './BatchStatusBadge';

const STATUS_OPTIONS = ['En Espera', 'Procesando', 'Listo para Venta', 'Completado', 'Cancelado'];

export default function StatusChangeModal({ batch, onClose, onConfirm }) {
  const [newStatus, setNewStatus] = useState(batch?.status);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="flex items-center justify-between p-5 border-b border-slate-200">
          <h2 className="text-base font-bold text-slate-800" style={{ fontFamily: '"Outfit", sans-serif' }}>
            Cambiar Estado
          </h2>
          <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors">
            <Icon name="X" size={16} color="currentColor" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          <div className="flex items-center gap-3 bg-slate-50 rounded-lg p-3">
            <span className="text-sm font-mono font-bold text-slate-700">{batch?.batchId}</span>
            <span className="text-sm text-slate-500" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>Estado actual:</span>
            <BatchStatusBadge status={batch?.status} />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
              Nuevo Estado
            </label>
            <div className="space-y-2">
              {STATUS_OPTIONS?.map(s => (
                <label key={s} className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${newStatus === s ? 'border-orange-400 bg-orange-50' : 'border-slate-200 hover:border-slate-300'}`}>
                  <input
                    type="radio"
                    name="status"
                    value={s}
                    checked={newStatus === s}
                    onChange={() => setNewStatus(s)}
                    className="text-orange-600 focus:ring-orange-500"
                  />
                  <BatchStatusBadge status={s} />
                </label>
              ))}
            </div>
          </div>
          <div className="flex items-center justify-end gap-3 pt-1">
            <Button variant="outline" size="sm" onClick={onClose}>Cancelar</Button>
            <Button variant="default" size="sm" onClick={() => onConfirm(batch?.id, newStatus)} iconName="Check" iconPosition="left">
              Confirmar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}